import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(`
    width:100%;
    justify-content: center;
`)
